import React, { useState } from 'react';

import { cn } from 'lib/helpers/utility';

import { calculateDayTotalMinutes } from 'components/practice/Settings/components/PracticeDetails/lib/workingHoursUtils';
import Icon from 'components/shared/Icon/Icon';
import Switch from 'components/shared/Switch/Switch';

import DayDetails from './DayDetails';
import { formatTotal } from './utils';

const DayCard = ({ day, expandedDay, setExpandedDay, handleToggleType, updateAvailableTimes }) => {
  const [activeTabByDay, setActiveTabByDay] = useState({});

  const totalMinutes = calculateDayTotalMinutes(day);
  const isOfficeOn = day.location?.starts_at != null && day.location?.ends_at != null;
  const isVirtualOn = day.virtual?.starts_at != null && day.virtual?.ends_at != null;
  const isExpanded = expandedDay === day.day;

  const handleLocalToggleType = (dayName, typeKey, checked) => {
    handleToggleType(dayName, typeKey, checked);

    // When toggling virtual ON, switch to virtual tab
    if (typeKey === 'virtual' && checked) {
      setActiveTabByDay((prev) => ({ ...prev, [dayName]: 'virtual' }));
    }
  };

  return (
    <div
      className={cn(
        'rounded-lg border border-solid border-neutral-200',
        day.available || isExpanded ? 'block' : 'hidden'
      )}>
      <button
        type="button"
        className="flex w-full cursor-pointer items-center justify-between px-4 py-3"
        onClick={() => setExpandedDay((prev) => (prev === day.day ? null : day.day))}>
        <div className="text-sm font-500 text-neutral-900">{day.day}</div>
        <div className="flex items-center gap-2">
          <span className="text-sm text-neutral-700">
            Total: <span className="font-600 text-neutral-800">{formatTotal(totalMinutes)}</span>{' '}
            hrs
          </span>
          <span className="text-neutral-400">/</span>
          <div
            className="flex items-center gap-2 text-xs font-500 text-neutral-800"
            onClick={(e) => e.stopPropagation()}>
            <span>Office</span>
            <Switch
              checked={isOfficeOn}
              onChange={(checked) => handleLocalToggleType(day.day, 'location', checked)}
            />
            <span className="text-neutral-400">/</span>
            <span>Virtual</span>
            <Switch
              checked={isVirtualOn}
              onChange={(checked) => handleLocalToggleType(day.day, 'virtual', checked)}
            />
          </div>

          <Icon
            icon={isExpanded ? 'chevron-up-linear' : 'chevron-down-linear'}
            size={20}
            color="neutral"
          />
        </div>
      </button>
      {isExpanded && (
        <DayDetails
          day={day}
          updateAvailableTimes={updateAvailableTimes}
          activeTab={activeTabByDay[day.day] || 'location'}
          setActiveTab={(tab) => setActiveTabByDay((prev) => ({ ...prev, [day.day]: tab }))}
        />
      )}
    </div>
  );
};

export default DayCard;
